export const userType = {
  NONE: 'NONE',
  USER: 'USER',
  VIP_USER: 'VIP_USER',
  COMPANY: 'COMPANY',
  GENERAL: 'GENERAL',
};
